export default __webpack_public_path__ + "static/media/yif-logo.c9935c44.svg";